// Данная функция используется для плавной прокрутки к элементу (работает также в IE и safari)
/* global $ */
export default function scrollToElement(element, header, marginTop) {
  const heightScroll = element.getBoundingClientRect().top;
  const headerHeight = header.clientHeight;

  $('html, body').stop().animate({
    scrollTop: heightScroll + window.scrollY - headerHeight - marginTop,
  }, 800);
}
